var Flickity = require('flickity-imagesloaded');



//////////////////
// WEBPACK FOOTER
// ./views/js/home.js
// module id = 17
// module chunks = 0